import React, { Fragment } from "react";
import { Link, matchPath } from "react-router-dom";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import {
  SITENAMEALIAS,
  SITENAME,
  LOGO,
  CAPTCHASITEKEY,
  DEMOBROKER,
} from "../utils/init";
import { updateFavicon } from "../utils/favicon";
import PhoneInput from "react-phone-input-2";
import { showToast, showHttpError } from "../utils/library";
import {
  Registration,
  EmailCheck,
  CaptchaVerify,
  coinSendToOther,
  getSignUpEmailOtp,
  getSignUpPhoneOtp,
  checkPhoneNo,
  ValidateRegistration,
  getBrokerDetails,
  getBrokerDetailsByBrokerId,
} from "../utils/service";
import PaybitoCaptcha from "../components/PaybitoCaptcha";
import logo from "../assets/images/paybitologo.png";
import Header from "../components/Header";
import { Helmet } from "react-helmet";

export default class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      isTermsChecked: false,
      captchaValue: "",
      isLoginButtonEnable: true,
      isFirstNameNotValid: false,
      isLastNameNotValid: false,
      isEmailNotValid: false,
      isPasswordNotValid: false,
      isOrgNameNotValid: false,
      signupPasswordType: false,
      isActive: false,
      eye: true,
      repswdeye: true,
      password: "",
      retypepassword: "",
      isPasswordMatched: "",
      type: false,
      repswdtype: false,
      phoneNumber: "",
      selectedCountry: "us",
      dialCode: "1",
      secondStatusCheckForEmailOtp: false,
      brokerId: null,
      country: "",
      backgroundImageStatus: 0,
      backgroundImageLink: "",
      exchangeName: "",
      exchangeLogo: "",
      companyName: "",
      exchangeLogoStatus: false,
      gender: "Male",
      backgroundColour: "",
      navbarColor: "",
      buttonColor: "",

      showCaptchaModal: false,
      gRecaptchaResponse: "",
      showBrokerIdField: false,
      referralCode: "",
    };

    /*** REFERENCE FOR RETRIEVING INPUT FIELDS DATA ***/
    this.organizationRef = React.createRef();
    this.firstNameRef = React.createRef();
    this.lastNameRef = React.createRef();
    this.emailRef = React.createRef();
    this.passwordRef = React.createRef();
    this.recaptchaRef = React.createRef();
    this.retypepasswordRef = React.createRef();
    this.brokerIdRef = React.createRef();
    this.captchaRef = React.createRef();
    this.referralCodeRef = React.createRef();
    // this.phoneNumberRef = React.createRef();

    this.getBrokerDetailsP();
  }

  getBrokerDetailsP = () => {
    const fixedBrokerId = "ATHA24102025105924";
    const urlParams = new URLSearchParams(window.location.search);
    const brokerId = urlParams.get("broker-id") || localStorage.getItem(SITENAMEALIAS + "_brokerId") || fixedBrokerId;

    localStorage.setItem(SITENAMEALIAS + "_broker_id", brokerId);
    localStorage.setItem(SITENAMEALIAS + "_brokerId", brokerId);
    localStorage.setItem("DEMOBROKERID", brokerId);

    this.fetchBrokerDetailsByBrokerId(brokerId);
  };

  getBrokerDetailsByDomain = () => {
    const brokerId = "ATHA24102025105924";
    localStorage.setItem(
      SITENAMEALIAS + "_brokerDomain",
      window.location.origin
    );
    localStorage.setItem(SITENAMEALIAS + "_broker_id", brokerId);
    localStorage.setItem(SITENAMEALIAS + "_brokerId", brokerId);
    this.fetchBrokerDetailsByBrokerId(brokerId);
  };

  fetchBrokerDetailsByBrokerId = (brokerId) => {
    if (!brokerId) {
      console.error("No broker ID provided to fetchBrokerDetailsByBrokerId");
      return;
    }

    console.log("Fetching broker details for broker ID:", brokerId);

    getBrokerDetailsByBrokerId(brokerId)
      .then(
        function (res) {
          console.log("Broker details response:", res.data);

          var bakgColor =
            "linear-gradient(90deg, " +
            res.data.color.backgroundColor1 +
            " 0%, " +
            res.data.color.backgroundColor2 +
            " 60%)";

          localStorage.setItem(SITENAMEALIAS + "_backgroundColour", bakgColor);
          localStorage.setItem(
            SITENAMEALIAS + "_navbarColour",
            res.data.color.navbarColor
          );
          localStorage.setItem(
            SITENAMEALIAS + "_buttonColour",
            res.data.color.buttonColor
          );

          localStorage.setItem(
            SITENAMEALIAS + "_isBackgroundImage",
            res.data.color.isBackgroundImage
          );

          localStorage.setItem(
            SITENAMEALIAS + "_backgroundImageLink",
            res.data.color.backgroundImageLink
          );

          this.setState({
            exchangeName: res.data.value[0].exchange,
            exchangeLogo: res.data.value[0].exchange_logo,
            companyName: res.data.value[0].company_name,
            backgroundColour: bakgColor,
            navbarColor: res.data.color.navbarColor,
            buttonColor: res.data.color.buttonColor,
            backgroundImageStatus: res.data.color.isBackgroundImage,
            backgroundImageLink: res.data.color.backgroundImageLink,
          });

          localStorage.setItem(
            SITENAMEALIAS + "_supportLink",
            res.data.value[0].support_link
          );

          // Always update localStorage with the latest broker details
          localStorage.setItem(
            SITENAMEALIAS + "_companyName",
            res.data.value[0].company_name
          );
          localStorage.setItem(
            SITENAMEALIAS + "_exchange",
            res.data.value[0].exchange
          );
          localStorage.setItem(
            SITENAMEALIAS + "_exchangeLogo",
            res.data.value[0].exchange_logo
          );
          updateFavicon();

          console.log("Broker configuration loaded successfully");
        }.bind(this)
      )
      .catch(function (err) {
        console.error("Error fetching broker details by ID:", err);
        showToast("error", "Unable to load broker configuration");
      });
  };

  /*
    Method defination for sending email and password and initiate login procedure through API Call
    */
  // handleSignup = (e) => {
  //   e.preventDefault();
  //   if (
  //     this.organizationRef.current.value != "" &&
  //     this.firstNameRef.current.value != "" &&
  //     this.lastNameRef.current.value != "" &&
  //     this.passwordRef.current.value != "" &&
  //     this.emailRef.current.value != "" &&
  //     this.state.isTermsChecked &&
  //     this.state.captchaValue != ""
  //   ) {
  //     this.setState({ showLoader: true });
  //     let payload = {
  //       organization_name: this.organizationRef.current.value,
  //       first_name: this.firstNameRef.current.value,
  //       last_name: this.lastNameRef.current.value,
  //       email: this.emailRef.current.value,
  //       password: this.passwordRef.current.value,
  //       gRecaptchaResponse: this.state.captchaValue,
  //     };
  //     Registration(payload)
  //       .then(
  //         function (res) {
  //           this.setState({ showLoader: false });
  //           var response = res.data[0];
  //           if (response.error != "0") {
  //             showToast("error", response.error_msg);
  //           } else {
  //             // showToast("success", "Successfully signup, login to continue");
  //             // let email = payload['email'];
  //             this.props.history.push("/otp");
  //             // coinSendToOther(email)
  //             //       .then(function (res) {
  //             //           var result = res.data[0];
  //             //           if(result.error != "0") {
  //             //             showToast("error", result.error_msg)
  //             //           } else {
  //             //               this.props.history.push("/otp");

  //             //           }
  //             //       }.bind(this))
  //             //       .catch(
  //             //         function(err) {
  //             //           this.setState({ showLoader: false });
  //             //           showHttpError(err);
  //             //         }.bind(this)
  //             //       );
  //           }
  //         }.bind(this)
  //       )
  //       .catch(
  //         function (err) {
  //           this.setState({ showLoader: false });
  //           showHttpError(err);
  //         }.bind(this)
  //       );
  //   } else {
  //     showToast(
  //       "error",
  //       "Please provide valid details & select terms & conditions"
  //     );
  //   }
  // };

  /*
    Method defination for calling API to check if email already exist which is given
    by user
    */
  handleEmailCheck = () => {
    if (this.emailRef.current.value != "") {
      this.setState({ showLoader: true });
      let payload = {
        email: this.emailRef.current.value,
      };
      EmailCheck(payload)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            var response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
              this.emailRef.current.value = "";
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    } else {
    }
  };

  /* Method definition for calling API to check if phone already exist which is given by user */
  handlePhoneCheck = () => {
    if (this.state.phoneNumber != "") {
      this.setState({ showLoader: true });
      let payload = {
        phone: this.state.phoneNumber,
        countryCode: this.state.dialCode,
      };
      checkPhoneNo(payload)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            var response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    } else {
    }
  };
  /* Method defination on change event for captcha*/
  handleOnCaptchaChange = (value) => {
    console.log("Captcha Value", value);
    this.setState(
      {
        captchaValue: value,
      },
      () => {
        // this.handleVerifyCapthcha(value);
        this.setState({
          isLoginButtonEnable: false,
        });
      }
    );
  };

  /* Method defination for verifing captcha */
  handleVerifyCapthcha = (token) => {
    this.setState({ showLoader: true });
    let payload = {
      gRecaptchaResponse: token,
    };
    CaptchaVerify(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          var response = res;
          console.log(response);
          if (response.data != "success") {
            showToast("error", response.statusText);
          } else {
            this.setState({
              isLoginButtonEnable: false,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  Eye = () => {
    if (this.state.password == "password") {
      this.setState({
        password: "text",
        eye: false,
        type: true,
      });
    } else {
      this.setState({
        password: "password",
        eye: true,
        type: false,
      });
    }
  };

  rePswdEye = () => {
    if (this.state.retypepassword == "password") {
      this.setState({
        retypepassword: "text",
        repswdeye: false,
        type: true,
      });
    } else {
      this.setState({
        retypepassword: "password",
        repswdeye: true,
        type: false,
      });
    }
  };

  sendEmailOtpForSignUp = () => {
    let payloadForEmail = {
      email: this.emailRef.current.value,
      temp_merchant_id: localStorage.getItem(
        SITENAMEALIAS + "_temp_merchant_id"
      ),
    };
    getSignUpEmailOtp(payloadForEmail)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Otp send to your given email ");
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          //console.log('3', err)
          showHttpError(err);
        }.bind(this)
      );
  };

  sendPhoneOtpForSignUp = () => {
    let payloadForPhone = {
      phone: this.state.phoneNumber,
      temp_merchant_id: localStorage.getItem(
        SITENAMEALIAS + "_temp_merchant_id"
      ),
    };
    getSignUpPhoneOtp(payloadForPhone)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("sucess", "Otp send to your given phone number");
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          //console.log('3', err)
          showHttpError(err);
        }.bind(this)
      );
  };

  setStateHandler = (newState) => {
    this.setState(newState);
  };

  handleSignupVerification = async (e) => {
    console.log("form submit");
    e.preventDefault();
    if (
      this.organizationRef.current.value != "" &&
      this.firstNameRef.current.value != "" &&
      this.lastNameRef.current.value != "" &&
      this.passwordRef.current.value != "" &&
      this.emailRef.current.value != "" &&
      this.state.isTermsChecked &&
      this.state.phoneNumber != ""
    ) {
      console.log("iiif");
      try {
        const { token } = await this.captchaRef.current.verify();
        this.handleCaptchaSubmit(token);
      } catch (err) {
        showToast("error", err.message || "Captcha verification failed");
      }
    } else {
      console.log("else");
      showToast(
        "error",
        "Please provide valid details & select terms & conditions"
      );
    }
  };

  handleCaptchaSubmit = async (captcha) => {
    this.setState({ showLoader: true });
    const emailState = await EmailCheck({
      email: this.emailRef.current.value,
    });
    if (emailState.data[0].error != "0") {
      showToast("error", emailState.data[0].error_msg);
      this.emailRef.current.value = "";
      this.setState({ showLoader: false });
      return;
    }
    const phoneState = await checkPhoneNo({
      phone: this.state.phoneNumber,
      countryCode: this.state.dialCode,
    });
    if (phoneState.data[0].error != "0") {
      showToast("error", phoneState.data[0].error_msg);
      this.setState({ phoneNumber: "", showLoader: false });
      return;
    }

    let payload = {
      first_name: this.firstNameRef.current.value,
      last_name: this.lastNameRef.current.value,
      email: this.emailRef.current.value,
      password: this.passwordRef.current.value,
      retype_password: this.retypepasswordRef.current.value,
      organization_name: this.organizationRef.current.value,
      phone: this.state.phoneNumber,
      countryCode: this.state.dialCode,
      gender: this.state.gender,
      gRecaptchaResponse: captcha,
      country: this.state.selectedCountry,
    };
    if (this.state.brokerId != null) {
      if (window.location.origin == "https://portal.paybito.com") {
        // this.setState({
        //   brokerId: localStorage.getItem('DEMOBROKERID')
        // })
        payload["brokerId"] = localStorage.getItem("DEMOBROKERID");
        localStorage.setItem(
          SITENAMEALIAS + "_broker_id",
          localStorage.getItem("DEMOBROKERID")
        );
      } else {
        payload["brokerId"] = this.state.brokerId;
        localStorage.setItem(SITENAMEALIAS + "_broker_id", this.state.brokerId);
        localStorage.setItem(SITENAMEALIAS + "_brokerId", this.state.brokerId);
      }
    }
    ValidateRegistration(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
            this.setState({ showLoader: false });
          } else {
            localStorage.setItem(
              SITENAMEALIAS + "_temp_merchant_id",
              response.temp_merchant_id
            );
            localStorage.setItem(
              SITENAMEALIAS + "_organization_name",
              this.organizationRef.current.value
            );
            localStorage.setItem(
              SITENAMEALIAS + "_first_name",
              this.firstNameRef.current.value
            );
            localStorage.setItem(
              SITENAMEALIAS + "_last_name",
              this.lastNameRef.current.value
            );
            localStorage.setItem(
              SITENAMEALIAS + "_email",
              this.emailRef.current.value
            );
            localStorage.setItem(
              SITENAMEALIAS + "_password",
              this.passwordRef.current.value
            );
            localStorage.setItem(
              SITENAMEALIAS + "_gcaptchaval",
              this.state.captchaValue
            );
            localStorage.setItem(
              SITENAMEALIAS + "_phone_number",
              this.state.phoneNumber
            );
            localStorage.setItem(
              SITENAMEALIAS + "_dialCode",
              this.state.dialCode
            );
            localStorage.setItem(SITENAMEALIAS + "_gender", this.state.gender);
            localStorage.setItem(
              SITENAMEALIAS + "_country",
              this.state.selectedCountry
            );
            localStorage.setItem(
              SITENAMEALIAS + "_referredBy",
              this.referralCodeRef.current.value
            );

            this.sendEmailOtpForSignUp();
            // this.sendPhoneOtpForSignUp();
            this.props.history.push("/otp");
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          //console.log('3', err)
          showHttpError(err);
        }.bind(this)
      );
  };

  componentDidMount() {
    updateFavicon(this.state.exchangeLogo);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.exchangeLogo !== this.state.exchangeLogo) {
      updateFavicon(this.state.exchangeLogo);
    }
  }

  render() {
    const signupForm = (
      <div className="login-background">
        <div className="row mb-2">
          <div className="col-12" style={{ marginTop: "100px" }}>
            <div className="card form-card" style={{ borderRadius: "10px" }}>
              <div className="card-body cardBody">
                <h4 className="card-title text-center signup-title">
                  Ready to create your{" "}
                  {localStorage.getItem(SITENAMEALIAS + "_exchange")} Merchant
                  account?
                </h4>
                <p className="text-center signup-subtitle">
                  We're glad to hear it! We just need a few pieces of
                  information to get you started.
                </p>
                <div className="forms-sample">
                  {/* Organization Name */}
                  <div className="login-float-group">
                    <input
                      type="text"
                      id="signupOrgName"
                      ref={this.organizationRef}
                      placeholder=" "
                      onKeyUp={() => {
                        var elmOrgName = this.organizationRef.current.value;
                        var regex = /^[A-Za-z0-9\s\-.]+$/gm;
                        if (!regex.test(elmOrgName)) {
                          this.setState({
                            isOrgNameNotValid: true,
                            isLoginButtonEnable: true,
                          });
                        } else {
                          this.setState({
                            isOrgNameNotValid: false,
                            isLoginButtonEnable: false,
                          });
                        }
                      }}
                    />
                    <label htmlFor="signupOrgName">Organization Name *</label>
                  </div>
                  {this.state.isOrgNameNotValid ? (
                    <small className="text-danger signup-validation">
                      Enter a valid Organization name
                    </small>
                  ) : (
                    ""
                  )}

                  {/* Gender / First Name / Last Name */}
                  <div className="row d-flex align-items-start m-0">
                    <div className="col-12 col-md-2 p-0 pr-md-2">
                      <div className="login-float-group gender-select-group">
                        <select
                          className="gender-select"
                          value={this.state.gender}
                          onChange={(e) =>
                            this.setState({ gender: e.target.value })
                          }
                        >
                          <option value="Male">Mr.</option>
                          <option value="Female">Mrs.</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12 col-md-5 p-0 pr-md-2">
                      <div className="login-float-group">
                        <input
                          type="text"
                          id="signupFirstName"
                          ref={this.firstNameRef}
                          placeholder=" "
                          onKeyUp={() => {
                            var elmName = this.firstNameRef.current.value;
                            var regex = /^[a-zA-Z]{2,20}$/;
                            if (!regex.test(elmName)) {
                              this.setState({
                                isFirstNameNotValid: true,
                                isLoginButtonEnable: false,
                              });
                            } else {
                              this.setState({
                                isFirstNameNotValid: false,
                                isLoginButtonEnable: true,
                              });
                            }
                          }}
                        />
                        <label htmlFor="signupFirstName">First Name *</label>
                      </div>
                      {this.state.isFirstNameNotValid ? (
                        <small className="text-danger signup-validation">
                          Enter a valid first name
                        </small>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-12 col-md-5 p-0">
                      <div className="login-float-group">
                        <input
                          type="text"
                          id="signupLastName"
                          ref={this.lastNameRef}
                          placeholder=" "
                          onKeyUp={() => {
                            var elmLastName = this.lastNameRef.current.value;
                            var regex = /^[a-zA-Z-]{2,20}( [a-zA-Z-]{2,20})?$/;
                            if (!regex.test(elmLastName)) {
                              this.setState({
                                isLastNameNotValid: true,
                                isLoginButtonEnable: true,
                              });
                            } else {
                              this.setState({
                                isLastNameNotValid: false,
                                isLoginButtonEnable: false,
                              });
                            }
                          }}
                        />
                        <label htmlFor="signupLastName">Last Name *</label>
                      </div>
                      {this.state.isLastNameNotValid ? (
                        <small className="text-danger signup-validation">
                          Enter a valid last name
                        </small>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {/* Email */}
                  <div className="login-float-group">
                    <input
                      type="email"
                      id="signupEmail"
                      ref={this.emailRef}
                      placeholder=" "
                      onBlur={this.handleEmailCheck}
                      onKeyUp={() => {
                        var emailVal = this.emailRef.current.value;
                        var regex =
                          /^[a-zA-Z0-9._%+-]{1,30}@[a-zA-Z0-9-]{1,30}\.[a-zA-Z]{2,}$/;
                        if (!regex.test(emailVal)) {
                          this.setState({
                            isEmailNotValid: true,
                            isLoginButtonEnable: false,
                          });
                        } else {
                          this.setState({
                            isEmailNotValid: false,
                            isLoginButtonEnable: true,
                          });
                        }
                      }}
                    />
                    <label htmlFor="signupEmail">Email Address *</label>
                  </div>
                  {this.state.isEmailNotValid ? (
                    <small className="text-danger signup-validation">
                      Enter a valid email
                    </small>
                  ) : (
                    ""
                  )}

                  {/* Broker ID */}
                  <div
                    className="login-float-group"
                    style={this.showBrokerIdField ? {} : { display: "none" }}
                  >
                    <input
                      type="text"
                      id="signupBrokerId"
                      ref={this.brokerIdRef}
                      placeholder=" "
                      onChange={() => {
                        let brokerIdForm = this.brokerIdRef.current.value;
                      }}
                    />
                    <label htmlFor="signupBrokerId">Broker ID *</label>
                  </div>

                  {/* Phone Number */}
                  <div className="signup-phone-group">
                    {/* <PhoneInput
                      placeholder="Enter phone number"
                      country={this.state.selectedCountry}
                      value={this.state.phoneNumber}
                      disableCountryGuess={true}
                      countryCodeEditable={false}
                      inputStyle={{ width: "100%" }}
                      onChange={(value, country) => {
                        console.log("phonenumberrr", value, country);
                        this.setState({
                          phoneNumber: value,
                          selectedCountry: country.countryCode, // always ISO code
                          dialCode: country.dialCode, // always ISO code
                        });
                      }}
                      onBlur={this.handlePhoneCheck}
                    /> */}

                    <PhoneInput
                      className="phone-input"
                      placeholder="Enter phone number"
                      country={this.state.selectedCountry}
                      value={this.state.dialCode + this.state.phoneNumber} // combine when displaying
                      disableCountryGuess={true}
                      countryCodeEditable={false}
                      inputStyle={{ width: "100%" }}
                      onChange={(value, country) => {
                        const dialCode = country.dialCode;

                        // Remove dial code from full value
                        let localNumber = value;
                        if (value.startsWith(dialCode)) {
                          localNumber = value.slice(dialCode.length);
                        }
                        console.log("phonenumberrr", localNumber, country);
                        this.setState({
                          phoneNumber: localNumber, // ✅ only number without dial code
                          selectedCountry: country.name,
                          dialCode: dialCode,
                        });
                      }}
                      onBlur={this.handlePhoneCheck}
                    />
                  </div>

                  {/* Password */}
                  <div className="login-float-group">
                    <input
                      type={this.state.password}
                      id="signupPassword"
                      ref={this.passwordRef}
                      placeholder=" "
                      style={{ paddingRight: "44px" }}
                      onKeyUp={() => {
                        var passwordVal = this.passwordRef.current.value;
                        var regex =
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.$!])[A-Za-z\d@.$!]{8,35}$/gm;
                        if (!regex.test(passwordVal) || passwordVal == "") {
                          this.setState({
                            isPasswordNotValid: true,
                            isLoginButtonEnable: true,
                          });
                        } else {
                          this.setState({
                            isPasswordNotValid: false,
                            isLoginButtonEnable: false,
                          });
                        }
                      }}
                    />
                    <label htmlFor="signupPassword">Password *</label>
                    <span className="password-toggle" onClick={this.Eye}>
                      <i
                        className={`fa ${
                          this.state.eye ? "fa-eye-slash" : "fa-eye"
                        }`}
                      ></i>
                    </span>
                  </div>
                  {this.state.isPasswordNotValid ? (
                    <small className="text-danger signup-validation">
                      The password should be of minimum 8, maximum 35 characters
                      and must contain at least one uppercase, one lowercase, a
                      number and a special character (only $ @ . ! are allowed
                      in special characters).
                    </small>
                  ) : (
                    ""
                  )}

                  {/* Retype Password */}
                  <div className="login-float-group">
                    <input
                      type={this.state.retypepassword}
                      id="signupRetypePassword"
                      ref={this.retypepasswordRef}
                      placeholder=" "
                      style={{ paddingRight: "44px" }}
                      onChange={() => {
                        let passwordVal = this.passwordRef.current.value;
                        let retypepasswordVal =
                          this.retypepasswordRef.current.value;
                        if (passwordVal == retypepasswordVal) {
                          this.setState({
                            isPasswordMatched: true,
                            isLoginButtonEnable: false,
                          });
                        } else {
                          this.setState({
                            isPasswordMatched: false,
                            isLoginButtonEnable: true,
                          });
                        }
                      }}
                      onKeyUp={() => {
                        var passwordVal = this.retypepasswordRef.current.value;
                        var regex =
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.$!])[A-Za-z\d@.$!]{8,35}$/gm;
                        if (!regex.test(passwordVal) || passwordVal == "") {
                          this.setState({
                            isLoginButtonEnable: true,
                          });
                        } else {
                          this.setState({
                            isLoginButtonEnable: false,
                          });
                        }
                      }}
                    />
                    <label htmlFor="signupRetypePassword">
                      Retype Password *
                    </label>
                    <span className="password-toggle" onClick={this.rePswdEye}>
                      <i
                        className={`fa ${
                          this.state.repswdeye ? "fa-eye-slash" : "fa-eye"
                        }`}
                      ></i>
                    </span>
                  </div>
                  {this.state.isPasswordMatched !== "" &&
                    (this.state.isPasswordMatched ? (
                      <small className="text-success signup-validation">
                        Password Matched
                      </small>
                    ) : (
                      <small className="text-danger signup-validation">
                        Password Mismatched
                      </small>
                    ))}

                  {/* Referral Code */}
                  <div className="login-float-group">
                    <input
                      type="text"
                      id="signupReferralCode"
                      ref={this.referralCodeRef}
                      placeholder=" "
                      value={this.state.referralCode}
                      onChange={(e) =>
                        this.setState({ referralCode: e.target.value })
                      }
                    />
                    <label htmlFor="signupReferralCode">
                      Referral code (Optional)
                    </label>
                  </div>

                  {/* Terms checkbox */}
                  <div className="signup-terms-group">
                    <input
                      type="checkbox"
                      className="checkbox-label"
                      style={{ marginTop: "2px" }}
                      onClick={() => {
                        this.setState(
                          {
                            isTermsChecked: !this.state.isTermsChecked,
                          },
                          () => {}
                        );
                      }}
                      value={this.state.isTermsChecked}
                    />
                    <label className="ml-2">
                      I read and agree to the{" "}
                      <a
                        target="_blank"
                        href={`${
                          window.location.origin
                        }/legal/terms-of-use-pay-services.html?broker-Id=${
                          localStorage.getItem("DEMOBROKERID") ||
                          localStorage.getItem("BROKERID_Domain") ||
                          this.state.brokerId
                        }`}
                      >
                        Terms of use
                      </a>{" "}
                      &{" "}
                      <a target="_blank" href={"/privacy-policy"}>
                        Privacy policy
                      </a>
                      .{" "}
                    </label>
                  </div>

                  {/* Submit button */}
                  <button
                    type="submit"
                    className="login-btn"
                    style={{
                      backgroundColor: localStorage.getItem(
                        SITENAMEALIAS + "_buttonColour"
                      ),
                    }}
                    onClick={(event) => {
                      this.handleSignupVerification(event);
                    }}
                  >
                    SUBMIT
                  </button>
                </div>

                <PaybitoCaptcha
                  ref={this.captchaRef}
                  sitekey={CAPTCHASITEKEY}
                />

                <div
                  className="login-links"
                  style={{ justifyContent: "center" }}
                >
                  <Link to="/">Already a member?</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{localStorage.getItem(SITENAMEALIAS + "_exchange")}</title>
        </Helmet>
        <nav
          className="navbar navbar-light extNavbar"
          style={{
            backgroundColor: this.state.navbarColor,
          }}
        >
          <div className="image-container">
            <img src={this.state.exchangeLogo} className="logo-cred " />
          </div>
        </nav>

        {this.state.backgroundImageStatus == 0 ? (
          <div
            className="login-wrapper signup-page"
            style={{
              background: this.state.backgroundColour,
            }}
          >
            {signupForm}
            {window.location.origin == DEMOBROKER ? (
              <div className="d-flex align-items-end flex-column bd-highlight mb-3 footer-data">
                <a href="https://www.paybito.com/">
                  <div className="btn btn-light mt-auto p-2 bd-highlight footer-data-text">
                    <img
                      src={logo}
                      alt=""
                      style={{ marginRight: 3, height: "30px" }}
                    />
                    Powered by PayBito infrastructure
                  </div>
                </a>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        ) : (
          <div
            className="login-wrapper signup-page"
            style={{
              backgroundImage: this.state.backgroundImageLink,
              backgroundRepeat: `no-repeat`,
              backgroundSize: `cover`,
              backgroundPosition: `center`,
              minHeight: `100%`,
            }}
          >
            {signupForm}
            {window.location.origin == DEMOBROKER ? (
              <div className="d-flex align-items-end flex-column bd-highlight mb-3 footer-data">
                <a href="https://www.paybito.com/">
                  <div className="btn btn-light mt-auto p-2 bd-highlight footer-data-text">
                    <img
                      src={logo}
                      alt=""
                      style={{ marginRight: 3, height: "30px" }}
                    />
                    Powered by PayBito infrastructure
                  </div>
                </a>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        )}

        <Loader show={this.state.showLoader} />
      </Fragment>
    );
  }

  componentWillMount() {
    const match = matchPath(this.props.history.location.pathname, {
      path: "/signup/:param1",
      exact: true,
      strict: false,
    });
    console.log(match);

    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get("ref");
    if (refCode) {
      this.setState({ referralCode: refCode });
    }

    if (match != null) {
      //console.log('in if')
      if (window.location.origin == "https://portal.paybito.com") {
        this.setState({
          brokerId: localStorage.getItem("DEMOBROKERID"),
        });
      } else {
        this.setState({
          brokerId: match.params.param1,
        });
      }
    } else {
      //console.log('in else')
    }
  }
}
